import i18n from "@/i18n";

export const contentTemplatesFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "resolution",
        label: i18n.t("common.resolution")
    },
    {
        key: "type",
        label: i18n.t("common.type"),
        formatter: formatType
    },
    {
        key: "actions",
        label: ""
    }
];

function formatType(value: string) {
    if (value === "fixedhtml") return i18n.t("posts.FixedHtml");
    return i18n.t("posts.Html");
}
